import useSeo from "@/lib/useSeo";

export default function Privacy() {
  useSeo({
    title: "Privacy Policy | ClariDent RCM",
    description: "How ClariDent RCM collects, uses, and protects the information you share through our website forms and services.",
    path: "/privacy",
  });

  return (
    <main data-testid="privacy-page">
      <section className="bg-slate-50 py-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <h1 className="font-display text-5xl tracking-tighter font-black text-navy-900">Privacy Policy</h1>
          <p className="mt-4 text-sm text-slate-500">Last updated: August 2026</p>
        </div>
      </section>
      <section className="max-w-3xl mx-auto px-6 py-16 space-y-8 text-sm sm:text-base text-slate-600 leading-relaxed">
        <div>
          <h2 className="font-display text-2xl font-semibold text-navy-900 mb-3">Information we collect</h2>
          <p>When you submit a form on this website (free RCM audit, consultation, contact, or career application), we collect the details you provide — such as your name, practice or company name, email address, phone number, and any message or documents you choose to share.</p>
        </div>
        <div>
          <h2 className="font-display text-2xl font-semibold text-navy-900 mb-3">How we use it</h2>
          <p>We use this information only to respond to your enquiry, deliver the services or audit you requested, and communicate with you about ClariDent RCM. We do not sell or rent your personal information to third parties.</p>
        </div>
        <div>
          <h2 className="font-display text-2xl font-semibold text-navy-900 mb-3">Data security</h2>
          <p>We follow HIPAA-ready security practices: secure data transfer protocols, strict access controls, and privacy-aware workflows for all client and candidate information we handle.</p>
        </div>
        <div>
          <h2 className="font-display text-2xl font-semibold text-navy-900 mb-3">Your choices</h2>
          <p>You may request access to, correction of, or deletion of your personal information at any time by emailing <a href="mailto:Billing@claridentrcm.com" className="text-teal-600 font-semibold">Billing@claridentrcm.com</a>.</p>
        </div>
      </section>
    </main>
  );
}
